var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb"},[_c('el-breadcrumb',{attrs:{"separator":">"}},_vm._l((_vm.breadcrumbs),function(breadcrumb){return _c('el-breadcrumb-item',{key:breadcrumb.path},[_vm._v(" "+_vm._s(breadcrumb.meta.title)+" ")])}),1),_c('i',{staticClass:"el-icon-question"}),_c('el-divider')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }